import { CheckIcon, DownloadIcon } from '@primer/octicons-react';
import { graphql, useFragment } from 'react-relay';

import { MATOrganizationStudentsXlsxCreateDialog_matOrganization$key } from '../../../relay/__generated__/MATOrganizationStudentsXlsxCreateDialog_matOrganization.graphql';
import { MATOrganizationStudentsXlsxCreateDialog_organizationStudentsXlsxCreateMutation } from '../../../relay/__generated__/MATOrganizationStudentsXlsxCreateDialog_organizationStudentsXlsxCreateMutation.graphql';
import Button from '../../core/Button';
import Dialog, { DialogProps } from '../../core/Dialog';
import FormLayout from '../../core/FormLayout';
import LinkButton from '../../core/LinkButton';
import MutationFormik, { MutationFormikProps } from '../../core/MutationFormik';
import NonFieldError from '../../core/NonFieldError';
import Text from '../../core/Text';
import UploadFieldv2 from '../../core/UploadField';
import View from '../../core/View';

const MATOrganizationStudentsXlsxCreateDialog_matOrganization = graphql`
  fragment MATOrganizationStudentsXlsxCreateDialog_matOrganization on MATOrganization {
    id
    studentsBulkCreateTemplateUrl
  }
`;

type Props = {
  matOrganization: MATOrganizationStudentsXlsxCreateDialog_matOrganization$key;
} & DialogProps &
  Pick<
    MutationFormikProps<MATOrganizationStudentsXlsxCreateDialog_organizationStudentsXlsxCreateMutation>,
    'config' | 'onSubmit' | 'connections'
  >;

const MATOrganizationStudentsXlsxCreateDialog = ({
  matOrganization,
  config,
  connections,
  onSubmit,
  ...props
}: Props) => {
  const { id, studentsBulkCreateTemplateUrl } = useFragment(
    MATOrganizationStudentsXlsxCreateDialog_matOrganization,
    matOrganization,
  );

  return (
    <Dialog wide {...props}>
      <Dialog.Header>
        <Text sx={{ fontSize: 3, fontWeight: 'bold' }}>학생 계정 벌크 생성하기</Text>
        <View mt={1}>
          <Text sx={{ fontSize: 1, fontWeight: 'medium', color: 'fg.subtle' }}>
            xlsx 파일을 양식에 맞게 업로드해 주세요
          </Text>
        </View>
      </Dialog.Header>
      <MutationFormik<MATOrganizationStudentsXlsxCreateDialog_organizationStudentsXlsxCreateMutation>
        mutation={graphql`
          mutation MATOrganizationStudentsXlsxCreateDialog_organizationStudentsXlsxCreateMutation(
            $input: OrganizationStudentsXlsxCreateInput!
          ) {
            organizationStudentsXlsxCreate(input: $input)
          }
        `}
        initialValues={{ organization: id }}
        config={config}
        onSubmit={onSubmit}
        connections={connections}
      >
        {({ handleSubmit }, { nonFieldErrorRef, scrollContainerRef }) => (
          <>
            <Dialog.Body ref={scrollContainerRef}>
              <FormLayout>
                <NonFieldError ref={nonFieldErrorRef} />
                <View>
                  <Text as={'label'} color={'fg.default'} fontSize={1}>
                    양식
                  </Text>
                  <LinkButton
                    href={studentsBulkCreateTemplateUrl}
                    download
                    leadingIcon={DownloadIcon}
                    size={'medium'}
                    variant={'outline'}
                    sx={{ mt: 1 }}
                  >
                    양식 다운로드
                  </LinkButton>
                </View>
                <UploadFieldv2 label={'파일'} name={'file'} required />
              </FormLayout>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant={'primary'} leadingIcon={CheckIcon} onClick={() => handleSubmit()}>
                생성하기
              </Button>
            </Dialog.Footer>
          </>
        )}
      </MutationFormik>
    </Dialog>
  );
};

export default MATOrganizationStudentsXlsxCreateDialog;
